module.exports = __webpack_public_path__ + "static/media/LK_Electricity.e96f3ecc.svg";